jQuery( document ).ready(function($) {
    $('.project-header').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.team-info').matchHeight({byRow: true, property: 'height', target: null, remove: false});
});

$ = jQuery;

jQuery(".slider-gallery").slick({

    // normal options...
    infinite: true,
    dots: false,
    arrows : true,
    slidesToShow: 2,
    prevArrow :$(".slider-gallery-nav .prev"),
    nextArrow : $(".slider-gallery-nav .next"),
    variableWidth : true,
    draggable : true,

    // the magic
    responsive: [{



    }, {

        breakpoint: 600,
        settings: {
            slidesToShow: 1,

        }

    }]
}).on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});